import { mapUserData } from "./helpers.mjs";
import { useEventBus } from "../events.mjs";
import * as Sentry from "@sentry/browser";
import { useState } from "#imports";
export function useStoredUser() {
  const user = useState("user", () => void 0);
  const isPendingAuth = useState("is-pending-auth", () => void 0);
  const { emit } = useEventBus();
  function setUser(data) {
    if (!data) {
      Sentry.setUser(null);
    }
    user.value = mapUserData(data);
    emit("SET_USER", user.value);
    Sentry.setUser({
      email: user.value?.email ?? "N/A",
      id: user.value?.email ?? "N/A"
    });
  }
  async function getUser() {
    if (isPendingAuth.value) {
      await isPendingAuth.value;
    }
    return user.value ?? null;
  }
  return {
    user,
    isPendingAuth,
    setUser,
    getUser
  };
}
